(function () {
  var CLOSE_FALLBACK = 450;

  var details = document.getElementById('HeaderDrawer');
  if (!details) return;

  var summary = details.querySelector('.oj-header__drawer-toggle');
  var panel = details.querySelector('.oj-header__drawer-panel');
  if (!summary || !panel) return;

  details.classList.add('oj-header__drawer--js');

  var closing = false;
  var timer = null;

  function open() {
    if (details.open) return;
    details.open = true;
    document.body.classList.add('oj-drawer-open');
    panel.getBoundingClientRect();
    details.classList.add('is-open');
  }

  function settle() {
    panel.removeEventListener('transitionend', onEnd);
    clearTimeout(timer);
    details.open = false;
    closing = false;
  }

  function onEnd(event) {
    if (event.target === panel && event.propertyName === 'transform') settle();
  }

  function close() {
    if (closing || !details.open) return;
    closing = true;
    details.classList.remove('is-open');
    document.body.classList.remove('oj-drawer-open');
    panel.addEventListener('transitionend', onEnd);
    timer = setTimeout(settle, CLOSE_FALLBACK);
  }

  summary.addEventListener('click', function (event) {
    event.preventDefault();
    if (details.open && !closing) close();
    else if (!details.open) open();
  });

  var closeButton = panel.querySelector('.oj-header__drawer-close');
  if (closeButton) closeButton.addEventListener('click', close);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  panel.addEventListener('click', function (event) {
    if (event.target.closest('a')) close();
  });
})();
